export const inputTextPattern = "[A-Za-z0-9 _.,/@()'-.]+";
export const inputPatternTitle = `Only symbols: A-Za-z0-9 _.,/@()'- are allowed`;
